export type VisitTypeId =
  | 'OASIS_E_START_OF_CARE'
  | 'OASIS_E1_START_OF_CARE'
  | 'OASIS_E_RESUMPTION_OF_CARE'
  | 'OASIS_E1_RESUMPTION_OF_CARE'
  | 'OASIS_E_RECERTIFICATION'
  | 'OASIS_E1_RECERTIFICATION'
  | 'OASIS_E_DISCHARGE'
  | 'OASIS_E1_DISCHARGE'
  | 'OASIS_E_START_OF_CARE_PT'
  | 'OASIS_E1_START_OF_CARE_PT'
  | 'OASIS_E_RESUMPTION_OF_CARE_PT'
  | 'OASIS_E1_RESUMPTION_OF_CARE_PT'
  | 'OASIS_E_RECERTIFICATION_PT'
  | 'OASIS_E1_RECERTIFICATION_PT'
  | 'OASIS_E_DISCHARGE_PT'
  | 'OASIS_E1_DISCHARGE_PT'
  | 'OASIS_E_START_OF_CARE_OT'
  | 'OASIS_E1_START_OF_CARE_OT'
  | 'OASIS_E_RESUMPTION_OF_CARE_OT'
  | 'OASIS_E1_RESUMPTION_OF_CARE_OT'
  | 'OASIS_E_RECERTIFICATION_OT'
  | 'OASIS_E1_RECERTIFICATION_OT'
  | 'OASIS_E_DISCHARGE_OT'
  | 'OASIS_E1_DISCHARGE_OT'
  | 'OASIS_E_START_OF_CARE_ST'
  | 'OASIS_E1_START_OF_CARE_ST'
  | 'OASIS_E_RESUMPTION_OF_CARE_ST'
  | 'OASIS_E1_RESUMPTION_OF_CARE_ST'
  | 'OASIS_E_RECERTIFICATION_ST'
  | 'OASIS_E1_RECERTIFICATION_ST'
  | 'OASIS_E_DISCHARGE_ST'
  | 'OASIS_E1_DISCHARGE_ST'
  | 'SKILLED_NURSING_ASSESSMENT'
  | 'SKILLED_NURSING_EVALUATION'
  | 'LPN_LVN_SKILLED_NURSING_VISIT'
  | 'RN_SKILLED_NURSING_VISIT'
  | 'PT_EVALUATION'
  | 'PT_RE_EVALUATION'
  | 'PT_VISIT'
  | 'PT_TREATMENT_VISIT'
  | 'PT_DISCHARGE'
  | 'PT_DISCHARGE_VISIT'
  | 'OT_EVALUATION'
  | 'OT_RE_EVALUATION'
  | 'OT_VISIT'
  | 'OT_TREATMENT_VISIT'
  | 'OT_DISCHARGE'
  | 'OT_DISCHARGE_VISIT'
  | 'ST_EVALUATION'
  | 'ST_RE_EVALUATION'
  | 'ST_VISIT'
  | 'ST_TREATMENT_VISIT'
  | 'ST_DISCHARGE'
  | 'ST_DISCHARGE_VISIT'
  | 'HOME_HEALTH_AIDE_VISIT'
  | 'HHA_STANDARD_VISIT';

/**
 * External system visit identifiers (aliases).

Multiple VisitTypeIds can map to the same FormType.
These are the names used by external systems (e.g., Wellsky, HCHB).
 */
/**
 * Array of all VisitTypeId values.
 * External system visit identifiers (aliases).

Multiple VisitTypeIds can map to the same FormType.
These are the names used by external systems (e.g., Wellsky, HCHB).
 */
export const VISITTYPEID_VALUES: readonly VisitTypeId[] = [
  'OASIS_E_START_OF_CARE',
  'OASIS_E1_START_OF_CARE',
  'OASIS_E_RESUMPTION_OF_CARE',
  'OASIS_E1_RESUMPTION_OF_CARE',
  'OASIS_E_RECERTIFICATION',
  'OASIS_E1_RECERTIFICATION',
  'OASIS_E_DISCHARGE',
  'OASIS_E1_DISCHARGE',
  'OASIS_E_START_OF_CARE_PT',
  'OASIS_E1_START_OF_CARE_PT',
  'OASIS_E_RESUMPTION_OF_CARE_PT',
  'OASIS_E1_RESUMPTION_OF_CARE_PT',
  'OASIS_E_RECERTIFICATION_PT',
  'OASIS_E1_RECERTIFICATION_PT',
  'OASIS_E_DISCHARGE_PT',
  'OASIS_E1_DISCHARGE_PT',
  'OASIS_E_START_OF_CARE_OT',
  'OASIS_E1_START_OF_CARE_OT',
  'OASIS_E_RESUMPTION_OF_CARE_OT',
  'OASIS_E1_RESUMPTION_OF_CARE_OT',
  'OASIS_E_RECERTIFICATION_OT',
  'OASIS_E1_RECERTIFICATION_OT',
  'OASIS_E_DISCHARGE_OT',
  'OASIS_E1_DISCHARGE_OT',
  'OASIS_E_START_OF_CARE_ST',
  'OASIS_E1_START_OF_CARE_ST',
  'OASIS_E_RESUMPTION_OF_CARE_ST',
  'OASIS_E1_RESUMPTION_OF_CARE_ST',
  'OASIS_E_RECERTIFICATION_ST',
  'OASIS_E1_RECERTIFICATION_ST',
  'OASIS_E_DISCHARGE_ST',
  'OASIS_E1_DISCHARGE_ST',
  'SKILLED_NURSING_ASSESSMENT',
  'SKILLED_NURSING_EVALUATION',
  'LPN_LVN_SKILLED_NURSING_VISIT',
  'RN_SKILLED_NURSING_VISIT',
  'PT_EVALUATION',
  'PT_RE_EVALUATION',
  'PT_VISIT',
  'PT_TREATMENT_VISIT',
  'PT_DISCHARGE',
  'PT_DISCHARGE_VISIT',
  'OT_EVALUATION',
  'OT_RE_EVALUATION',
  'OT_VISIT',
  'OT_TREATMENT_VISIT',
  'OT_DISCHARGE',
  'OT_DISCHARGE_VISIT',
  'ST_EVALUATION',
  'ST_RE_EVALUATION',
  'ST_VISIT',
  'ST_TREATMENT_VISIT',
  'ST_DISCHARGE',
  'ST_DISCHARGE_VISIT',
  'HOME_HEALTH_AIDE_VISIT',
  'HHA_STANDARD_VISIT',
] as const;
